import React, { Component } from 'react'
import InternalNotesFC from './InternalNotesFC'
import InternalNotesComments from './InternalNotesComments'
import Service from '../../../services';
import { AxiosError, AxiosResponse } from 'axios';
import { internalNotesModel } from '../../../models/InternalNotes';
import { catchError } from '../../../utils/Utils';
import { WithRouterProps, withRouter } from '../../shared/WithRouter';
import { UserData, mentionsUsers } from '../../../models/SharedModel';
import FinSpinner from '../../../commonfields/FinSpinner';
import { withContext } from '../../Authentication/RoleAuthorizationClassComponent';
import { Pages, actionAuthorization } from '../../../utils/RolesUtil';
import { BankUserContext } from '../../../bankUserContext';


interface initialProps {
  refreshComponent: boolean;
  context:any;
}

interface internalNotesState {
  internalNotesArray: internalNotesModel[];
  usersData: mentionsUsers[];
  loader: boolean;
}

class InternalNotes extends Component<WithRouterProps<initialProps>, internalNotesState> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: any) {
    super(props)
    this.state = {
      internalNotesArray: [],
      usersData: [],
      loader: false
    }
    this.service = new Service();
  }


  componentDidMount(): void {
    this.getInternalNotes();
    this.getUsers();
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<internalNotesState>, snapshot?: any): void {
    if (prevProps.refreshComponent !== this.props.refreshComponent) {
      this.getInternalNotes();
      this.getUsers();
    }
  }

  getInternalNotes = () => {
    if (this.props.params.clientProductsId) {
      const data = {
        "screen": "ProspectDetails",
        "sections": "GetClientComments",
        "isJsonReturnObject": true,
        "clientProductId": this.props.params.clientProductsId
      }
      this.setState({ loader: true });
      this.service.getInternalNotes(data).then((response: AxiosResponse<internalNotesModel[]>) => {
        let responseData = response.data || []
        if (responseData.length > 0) {
          responseData = responseData.map((m) => {
            if (m?.userIds && m?.userIds !== "") {
              try {
                const parsedUserIds = JSON.parse(m.userIds);
                return { ...m, userIds: parsedUserIds };
              } catch (error) {
                return { ...m, userIds: [] };
              }
            }
            return { ...m, userIds: [] };
          });
        }
        this.setState({ internalNotesArray: responseData })
      }).catch((error: AxiosError) => {
        catchError(error, true)
      }).finally(() => {
        this.setState({ loader: false })
      })
    }
  }

  getUsers = () => {
    const data = {
      "screen": "ProspectDetails",
      "sections": "getUsers",
      orgId: this.context?.bankuserDetails?.organization?.orgId,
    }
    this.service.getAllUsers(data).then((response: AxiosResponse<UserData[]>) => {
      const usersData = response.data?.map((m: UserData) => {
        return {
          id: m.userId,
          display: m.firstName,
        };
      }) || [];
      this.setState({ usersData: usersData })
    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  }



  render() {
    const {readOnlyMode} = this.props?.context;
    return (
      <div>
        {this.state.loader && <FinSpinner />}
        {withContext(this.context, Pages.customerDetailsPage, actionAuthorization.addInternalNotes) && !readOnlyMode &&
          <InternalNotesFC usersData={this.state.usersData}
            getInternalNotes={this.getInternalNotes}
          />}

        {
          this.state.internalNotesArray ? <ul className='notes-ul'>
            {
              this.state.internalNotesArray.map((m: internalNotesModel) => <InternalNotesComments
                key={m.clientCommentId}
                getInternalNotes={this.getInternalNotes} Comment={m} usersData={this.state.usersData} />)
            }

          </ul> : <div className='noRecordsContainer'><p>No Comments</p></div>
        }
      </div>
    )
  }
}

export default withRouter<WithRouterProps<initialProps>>(InternalNotes)